declare global {
  // Public runtime envs, injected into the page by the app.
  var __ENV__: Record<string, string> | undefined;
}

const PUBLIC_ENVS_TEMPLATE_ID = "public-envs";

const readPublicEnvsFromTemplate = () => {
  if (typeof document === "undefined") {
    return undefined;
  }

  const publicEnvs = document
    .getElementById(PUBLIC_ENVS_TEMPLATE_ID)
    ?.getAttribute("data-env");

  if (!publicEnvs) {
    return undefined;
  }

  try {
    return JSON.parse(publicEnvs) as Record<string, string>;
  } catch {
    return undefined;
  }
};

const getRuntimeEnvs = () => {
  if (typeof window === "undefined") {
    return undefined;
  }

  if (window.__ENV__) {
    return window.__ENV__;
  }

  const publicEnvs = readPublicEnvsFromTemplate();

  if (publicEnvs) {
    window.__ENV__ = publicEnvs;
  }

  return publicEnvs;
};

export default getRuntimeEnvs;
